import React from 'react';
import { Link } from 'react-router-dom'
import '../App.css';


function About() {
  return <>


        <div className="container lg:mx-4 mb-2">

       <h1 className='text-5xl mb-6'>Github Finder</h1>
      <p className='mb-4 text-xl font-light ml-1 lg:text-2xl max-w-6xl'>
        A React app to search GitHub profiles and see profile details. The
        project is build using
        <a href='https://www.udemy.com/course/modern-react-front-to-back/'>
          {' '}
          React,Reducers,Tailwind etc
        </a>{' '}
        User Github repsoitories,User entire details including images will come while searching.
        <strong>
          <a href='https://devdojo.com/rojinpm2024'>Rojin Pm</a>
        </strong>
        .
      </p>
      <p className='text-lg text-red-500 ml-1 font-semibold'>
        Version <span className='text-black font-semibold'>1.0.0</span>
      </p>
      <p className='text-lg text-red-500 ml-1 font-semibold'>
        Layout By:
        <a className='text-gray-600 font-semibold m-1' href='https://twitter.com/hassibmoddasser'>
          Rohith Santhosh
        </a>
      </p>
       
        <div className="btn-section">

           <Link className='btn back mt-5 ml-1 w-40 text-sm ease-out duration-300 hover:bg-purple-500 hover:scale-x-105 hover:scale-y-105 focus:outline-none border-purple-800' to="/">Back</Link>

        </div>


       </div>
     
  

  
  </>
}

export default About;
